import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b20a1ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"12px","font-weight":"bold"} }, "支付方式", -1))
const _hoisted_3 = { class: "account-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授信", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "权益金", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "现金", -1))
const _hoisted_7 = { class: "total" }
const _hoisted_8 = { class: "tips" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_OioFormItem = _resolveComponent("OioFormItem")!
  const _component_OioInputNumber = _resolveComponent("OioInputNumber")!
  const _component_OioForm = _resolveComponent("OioForm")!
  const _component_OioSpin = _resolveComponent("OioSpin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OioSpin, { loading: _ctx.formLoading }, {
      default: _withCtx(() => [
        _createVNode(_component_OioForm, {
          ref: "formRef",
          data: _ctx.formData
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createVNode(_component_OioFormItem, {
                validateStatus: _ctx.validation1.status,
                help: _ctx.validation1.help
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown",
                    placeholder: "请选择支付方式",
                    style: {"width":"100%"},
                    getPopupContainer: (triggerNode) => triggerNode.parentNode,
                    "default-active-first-option": false,
                    "filter-option": false,
                    "not-found-content": null,
                    options: _ctx.itemOptions,
                    mode: _ctx.formData.isCombination ? 'tags' : '',
                    value: _ctx.formData.checkedAccountTypeList,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.checkedAccountTypeList) = $event)),
                    onChange: _ctx.changePayType
                  }, null, 8, ["getPopupContainer", "options", "mode", "value", "onChange"])
                ]),
                _: 1
              }, 8, ["validateStatus", "help"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.creditFundBooks || [], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "account-item",
                  key: index
                }, [
                  _createVNode(_component_OioFormItem, {
                    label: item.fundBookName,
                    name: ['creditFundBooks', index, 'payAmount'],
                    rules: [{ validator: _ctx.payNumValidator(item), trigger: 'change' }],
                    extra: `本次可用：${item.payMinUseBalance + ' ~ ' + item.payMaxUseBalance}，余额：${item.usableAmount}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_OioInputNumber, {
                        value: item.payAmount,
                        "onUpdate:value": ($event: any) => ((item.payAmount) = $event),
                        placeholder: "请输入支付金额",
                        precision: 2,
                        formatter: (val) => Number(val).toFixed(2),
                        min: 0,
                        disabled: !item.eidtable,
                        onChange: _ctx.changePayValue
                      }, {
                        prepend: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value", "formatter", "disabled", "onChange"])
                    ]),
                    _: 2
                  }, 1032, ["label", "name", "rules", "extra"])
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.rebateFundBooks || [], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "account-item",
                  key: index
                }, [
                  _createVNode(_component_OioFormItem, {
                    label: item.fundBookName,
                    name: ['rebateFundBooks', index, 'payAmount'],
                    rules: [{ validator: _ctx.payNumValidator(item), trigger: 'change' }],
                    extra: `本次可用：${item.payMinUseBalance + ' ~ ' + item.payMaxUseBalance}，余额：${item.usableAmount}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_OioInputNumber, {
                        value: item.payAmount,
                        "onUpdate:value": ($event: any) => ((item.payAmount) = $event),
                        placeholder: "请输入支付金额",
                        precision: 2,
                        formatter: (val) => Number(val).toFixed(2),
                        min: 0,
                        disabled: !item.eidtable,
                        onChange: _ctx.changePayValue
                      }, {
                        prepend: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value", "formatter", "disabled", "onChange"])
                    ]),
                    _: 2
                  }, 1032, ["label", "name", "rules", "extra"])
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.fundBooks || [], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "account-item",
                  key: index
                }, [
                  _createVNode(_component_OioFormItem, {
                    label: item.fundBookName,
                    name: ['fundBooks', index, 'payAmount'],
                    rules: [{ validator: _ctx.payNumValidator(item), trigger: 'change' }],
                    extra: `本次可用：${item.payMinUseBalance + ' ~ ' + item.payMaxUseBalance}，余额：${item.usableAmount}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_OioInputNumber, {
                        value: item.payAmount,
                        "onUpdate:value": ($event: any) => ((item.payAmount) = $event),
                        placeholder: "请输入支付金额",
                        precision: 2,
                        formatter: (val) => Number(val).toFixed(2),
                        min: 0,
                        disabled: !item.eidtable
                      }, {
                        prepend: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value", "formatter", "disabled"])
                    ]),
                    _: 2
                  }, 1032, ["label", "name", "rules", "extra"])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: "num",
                style: _normalizeStyle({ borderColor: _ctx.isAbove ? 'var(--oio-error-color)' : 'var(--oio-input-border-color)' })
              }, "本次合计支付：¥" + _toDisplayString(_ctx.totalAmount.toFixed(2)) + "元", 5),
              _withDirectives(_createElementVNode("span", _hoisted_8, "支付金额超过应付款金额，请仔细核对", 512), [
                [_vShow, _ctx.isAbove]
              ])
            ])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}